<script setup lang="ts">
  import type { Email, Task } from '@stuut/api/models';
  import { Shimmer } from '@ui/components/ai-elements/shimmer';

  import TaskEmailResponse from '@/components/emails/EmailResponseTask.vue';
  import EmailTaskButtons from '@/components/tasks/EmailTaskButtons.vue';

  interface Props {
    email: Email;
    isProcessing?: boolean;
    processingLabel?: string;
    threadEmails: Email[];
  }

  defineProps<Props>();

  defineEmits<{
    (e: 'draft-created', email: Email): void;
    (e: 'draft-replaced', email: Email): void;
    (e: 'open-task', task: Task): void;
    (e: 'before-task-open'): void;
  }>();
</script>

<template>
  <div
    class="flex flex-col bg-muted/20 dark:bg-muted/15 border border-border/60 pt-5 pb-2 mx-5 mt-5 rounded-sm px-6"
  >
    <span class="text-2xs uppercase tracking-widest font-bold text-muted-foreground">
      Action Items
    </span>

    <TaskEmailResponse
      v-if="email.openResponseTasks?.length"
      :email="email"
      :thread-emails="threadEmails"
      @draft-created="$emit('draft-created', $event)"
      @draft-replaced="$emit('draft-replaced', $event)"
    />

    <EmailTaskButtons
      v-if="email.tasks?.length"
      class="-mx-6"
      :email="email"
      @open-task="$emit('open-task', $event)"
      @before-task-open="$emit('before-task-open')"
    />

    <div v-if="!email.tasks?.length && isProcessing" class="px-6 py-3 flex items-center gap-2.5">
      <i class="fa-solid fa-sparkles text-agent text-xs" />
      <Shimmer as="span" :duration="1.5" class="text-xs">
        {{ processingLabel }}
      </Shimmer>
    </div>
  </div>
</template>
